import React from 'react';
import {Page, Text, View, Image} from '@react-pdf/renderer';
import {imagePath} from "../../utils/imageUtils";
import {convertYMDtoDMY} from "../../utils/dateTimeUtils";
import {BarCode, Box, Column, Columns, LabeledText, Title} from "./pdf_common";
import { getBoardingPassImage } from '../../utils/themeUtils';
import { getTranslation } from '../../utils/translationUtils';


function AMBBoardingPassPage(props) {
    return (
        <Page size="A4" style={{
            flexDirection: 'column',
            backgroundColor: 'white',
            fontFamily: "pdfFont",
        }}>
            <Image src={imagePath(getBoardingPassImage())} style={{width: "100%", height: "auto"}}/>
            <View style={{
                padding: "24px 36px 36px 36px",
                fontSize: "10.5px",
                flex: 1,
                display: "flex",
            }}>
                <BarCode number={props.passenger.boardingPassCode} />

                <Box>
                    <Columns>
                        <Column>
                            <LabeledText label="Booking Reference" value={props.bookingData.bookingReference} />
                            <LabeledText label="Guest Name" value={`${props.passenger.title} ${props.passenger.firstName} ${props.passenger.lastName}`} />
                        </Column>
                        <Column>
                            <LabeledText label="Cruise Code" value={props.bookingData.itineraryCode} />
                            <LabeledText label="Cruise Title" value={props.bookingData.itineraryName} />
                        </Column>
                    </Columns>
                </Box>

                <Box>
                    <Columns>
                        <Column>
                            <LabeledText label="Ship Name" value={props.bookingData.shipName} />
                            <LabeledText label="Deck Number" value={props.passenger.deckNumber} />
                        </Column>
                        <Column>
                            <LabeledText label="Cabin Number" value={props.passenger.cabinNumber} />
                            <LabeledText label="Cabin Category" value={props.passenger.cabinCategory} />
                        </Column>
                    </Columns>
                </Box>

                <Box>
                    <Columns>
                        <Column>
                            <LabeledText label="Embarkation Date" value={convertYMDtoDMY(props.bookingData.embarkationDate)} />
                            <LabeledText label="Embarkation Time" value={props.passenger.embarkationTime} />
                            <LabeledText label="Embarkation Closing Time" value={props.passenger.embarkationClosingTime} />
                            <LabeledText label="Embarkation Port" value={getTranslation(props.bookingData.departurePort)} />
                        </Column>
                        <Column>
                            <LabeledText label="Disembarkation Date" value={convertYMDtoDMY(props.bookingData.disembarkationDate)} />
                            <LabeledText label="Disembarkation Port" value={getTranslation(props.bookingData.arrivalPort)} />
                        </Column>
                    </Columns>
                    <LabeledText label="Ship Berthed" value={props.bookingData.shipBerthed}/>
                </Box>

                <Box>
                    <Title>
                        Emergency Contact Numbers:
                    </Title>
                    <LabeledText label="Always Here Emergency Support" value="+44 (0)7587 814 254 / +44 (0)1708 973 601"/>
                    <LabeledText label="Ship’s number" value={props.bookingData.shipPhone}/>
                </Box>

                <Box style={{flex: 1}}>
                    <Title>
                        Additional Notes
                    </Title>
                    {props.bookingData?.notes?.PickupInstruction &&
                    <Text style={{marginTop: "2px"}}>
                        {props.bookingData.notes.PickupInstruction}
                    </Text>
                    }
                </Box>
                <View style={{display:"flex", alignItems:"center", marginTop: "20px"}}>
                    <Image src={imagePath('boarding_pass_footer.jpg')} style={{width: "65%", height: "auto"}} />
                </View>
            </View>
        </Page>
    );
}

export default AMBBoardingPassPage;